// extracted by mini-css-extract-plugin
export var auto = "_4l-1";
export var spinner = "_4l-0";